import { createSelector } from '@reduxjs/toolkit';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { Category, SuggestionResult } from 'core/type/SuggestionResult.types';
import { selectPageTypeId } from 'store/slice/navigation';
import { selectConfigFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { isCityPage, isSearchPage } from 'core/constant/analytics/AnalyticsPageType';
import { ScreenSize, selectScreenSize } from 'store/slice/screen';
import { ActivityCardProps } from 'core/type/ActivityCard.types';

interface StateProps {
    config: BootstrapConfig;
    screenSize: ScreenSize;
    isSearchBoxFeatureGroup: boolean;
    isInCitySearch: boolean;
    isGlobalKeywordSearch: boolean;
}

interface OwnProps {
    searchText: string;
    onSelect: (result: SuggestionResult, category?: Category) => void;
    popularActivities?: ActivityCardProps[];
    areSuggestionsLoading: boolean;
    suggestions: SuggestionResult[];
}

export type TextSearchResultsProps = OwnProps & StateProps;

export const mapStateToProps = createSelector(
    selectPageTypeId,
    selectConfigFromBootstrap,
    selectScreenSize,
    selectFeatureBehaviorFromBootstrap,
    (pageTypeId, config, screenSize, featureBehaviors): StateProps => {
        const isSearchBoxFeatureGroup = featureBehaviors.SearchBoxFeatureGroup;
        return {
            config,
            screenSize,
            isSearchBoxFeatureGroup,
            isInCitySearch: (isCityPage(pageTypeId) || isSearchPage(pageTypeId)) && isSearchBoxFeatureGroup,
            isGlobalKeywordSearch: featureBehaviors.GlobalKeywordSearch,
        };
    },
);
